const key = "add-no-conditions";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = () => ({
	"Id": 6,
	"Title": "No Conditions",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 4,
		"Code": "EMPTY",
		"Name": "Empty"
	},
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithNoConditions = ruleJson();
	resp.data.Data.Rules.push(ruleWithNoConditions);
};

export const addNoConditions = [key, applicable, modify];